import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from 'react';
import React from 'react';
import Home from './Home/Home';
import Layout from './Common/Layout/Layout';
import axios from 'axios';
import { PrivateRoute } from './Common/Components/PrivateRoute';
import Mastermind from './Games/Mastermind/Routes/Mastermind';
import Minesweeper from './Games/Minesweeper/Routes/Minesweeper';
import Shopping from './Shopping/Routes/Shopping';
import ShoppingInput from './Shopping/Routes/ShoppingInput';

export default function App() {
    useEffect(() => {
        document.title = 'Shavahar';
    }, []);

    axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL!;

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route index element={<Home />} />
                    <Route path="games/minesweeper" element={<Minesweeper />} />
                    <Route path="games/mastermind" element={<Mastermind />} />
                    <Route path="shopping" element={<PrivateRoute />}>
                        <Route index element={<Shopping />} />
                        <Route path="input" element={<ShoppingInput />} />
                    </Route>
                </Route>
            </Routes>
        </BrowserRouter>
    );
}